import { useState } from 'react';
import Combobox from '@/components/Combobox';
import { useDebouncedCallback } from '@/hooks/useDebouncedCallback';
import type { ValueToLabelCache } from '@/hooks/useValueToLabelCache';
import { usePositions } from './-query';
import type { PositionOption } from './-query/type';
interface PositionComboboxProps {
  value: string | null;
  onValueChange: (value: string | null, option?: PositionOption) => void;
  valueToLabelCache: ValueToLabelCache;
}
export const PositionCombobox = ({
  value,
  onValueChange,
  valueToLabelCache
}: PositionComboboxProps) => {
  const [searchText, setSearchText] = useState('');
  const debouncedSetSearchText = useDebouncedCallback((text: string) => setSearchText(text), []);
  const {
    data: options,
    isLoading
  } = usePositions(searchText);
  const handleValueChange = (newValue: string | null) => {
    const option = options?.find(option => option.value === newValue);
    onValueChange(newValue, option);
  };
  return <Combobox<PositionOption> type="single" value={value} options={options} isFetching={isLoading} onValueChange={handleValueChange} onSearchChange={debouncedSetSearchText} valueToLabelCache={valueToLabelCache} />;
};